import React from 'react'
import './publication.css'
import pelcovervol27no1 from "./PELCoverVol27No1.jpeg"

function Volume27no1() {
  return (
    <div className="p-2">
      <section className='content-header d-flex flex-column justify-content-start'>
        
        <strong><h3 className="p-2" >Vol. 27, Nos. 1&2, March/June 2026</h3></strong>
        <div><img src={pelcovervol27no1} alt=" PEL Cover Vol 27 No 1" className ="col-6 col-lg-4 col-md-4"/></div>
        <h5 className="p-2">CONTENTS</h5>
            <div className="p-2 contents">
             <a href= '/volume-27-no1/MythicalThoughtsandIdeologicalBordersAbahTMJuliusJBJosephNEandChibuikeNC.pdf'><p>Mythical Thoughts and Ideological Borders in Chinua Achebe’s Arrow of God - <strong>Thomas Michael Abah, Joseph Gbenga Julius, Nenfort E. Joseph, & Nwafor Charles Chibuike</strong> - 1 </p> </a> 
              </div>
              <div className="p-2">
            <a href= '/volume-27-no1/ACorpusFeministCriticalDiscourseAnalysisAragbuwaA.pdf'><p>A Corpus Feminist Critical Discourse Analysis of Nigerian Online News Reports on Human Trafficking - 
<strong> Adetutu Aragbuwa </strong> - 15 </p></a> 
              </div>
              <div className="p-2">
              <a href= '/volume-27-no1/InferentialityRealisationsandCognitivepragmaticSkillsDirisuA.pdf'><p>Inferentiality Realisations and Cognitive-pragmatic Skills in Primary School Pupils’ Reading Comprehension, Ogun State, Nigeria -  
 <strong>Abosede Dirisu </strong> - 33 </p></a>
              </div>
               <div className="p-2">
              <a href= '/volume-27-no1/SpeakingintoSacredSilenceEzeDikeFUIhuaMaduenyiRCandUnweneHE.pdf'><p>Speaking into Sacred Silence: The Sanhedrin as a Metaphor of Patriarchal Control within Church Spaces in Chimamanda Ngozi Adichie’s Purple Hibiscus and Ayọbámi Adébáyọ̀’s Stay with Me” -  
 <strong>Felicia Ukachi Eze-Dike, Ramatu Chiemele Ihua-Maduenyi & Hannah Ebere Unwene </strong> - 52 </p></a>
              </div>
              <div className="p-2">
              <a href= '/volume-27-no1/ViolentConflictsandPostcolonialIdentityUmarOandLarIB.pdf'><p>Violent Conflicts and Postcolonial Identity in Dul Johnson's Deeper into the Night  -  
 <strong>Oluwatoyin Umar & Isaac Barko Lar </strong> - 62 </p></a>
              </div>
              <div className="p-2">
              <a href= '/volume-27-no1/RepresentationsofPeoplewithDisabilitiesUmhanlenEandUgoanahFN.pdf'><p>Representations of People with Disabilities: A Multimodal Critical Discourse Analysis of Selected Instagram Posts from Disability Rights Advocacy Centre (DRAC) -  
 <strong>Endurance Umhanlen & Felix N. Ogoanah </strong> - 73 </p></a>
              </div>
              <div className="p-2">
              <a href= '/volume-27-no1/PhonologicalRealisationsofSchwaSoundAyindeOO.pdf'><p>Phonological Realisations of Schwa Sound by Yoruba-English Bilingual University Students -  
 <strong>Olusoga Oludotun Ayinde </strong> - 93 </p></a>
              </div>
            <hr/>
        </section> 
    </div>
  )
}

export default Volume27no1;